export function Views({ count }: { count: number }) {
  return (
    <div>
      <span className='font-normal mr-1'>{count.toLocaleString()}</span>
      <span className='text-sm font-light'>view{count > 1 && 's'}</span>
    </div>
  )
}